import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.incident-aktualisieren2';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsIncidentAktualisieren2Effects {

    IncidentAktualisieren2$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_INCIDENT_AKTUALISIEREN2),
        mergeMap((x: ac.PostIncidentAktualisieren2Action) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postIncidentAktualisieren2(x.incidentAktualisieren2Request).pipe(
                map((result: any) => {
                    return new ac.PostIncidentAktualisieren2ErfolgreichAction(result, x.incidentAktualisieren2Request, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostIncidentAktualisieren2FehlerAction(error, x.incidentAktualisieren2Request, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentsCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentsCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentsCommandService);
        }
        return this.service;
    }
}
